import React from 'react';
import { SxProps } from '@mui/system';
import { DatePicker as DatePickerBase } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { ComponentSize, COMPONENT_SIZE_MAP } from '../../types/types';

const StyledDatePicker = styled(DatePickerBase)<{ $size?: ComponentSize }>`
  .MuiInputBase-root {
    height: ${({ $size }) => COMPONENT_SIZE_MAP[$size || 'medium']}px;
    font-size: 14px;
    min-height: ${({ $size }) => COMPONENT_SIZE_MAP[$size || 'medium']}px;
  }

  & .MuiInputLabel-root {
    top: -6px;
  }

  & .MuiInputLabel-shrink {
    top: 0;
  }

  .MuiIconButton-root {
    height: 32px;
    width: 32px;
  }

  .MuiSvgIcon-root {
    height: 20px;
    width: 20px;
  }
`;

type Props = {
  value?: dayjs.Dayjs | null;
  onChange: (newValue: dayjs.Dayjs | null) => void;
  format?: string;
  disableFuture?: boolean;
  label?: string;
  sx?: SxProps;
  size?: ComponentSize;
} & React.ComponentProps<typeof DatePickerBase>;

const DatePicker = ({
  value,
  onChange,
  format = 'LL',
  disableFuture = false,
  label = 'Select Date',
  sx,
  size = 'medium',
  ...props
}: Props) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <StyledDatePicker
      label={label}
      value={value}
      onChange={onChange}
      format={format}
      disableFuture={disableFuture}
      sx={sx}
      $size={size}
      {...props}
    />
  </LocalizationProvider>
);

export default DatePicker;
